import { apiGeneral, queryBuilder } from "services";
import type { Company } from 'interfaces/company';
import type { OptionTypeBase } from 'interfaces/react-select';
export interface FetchCompaniesResponse {
  data: Company[];
  options: OptionTypeBase[]
}

export function useCompany() {
  const getListCompany = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get(`/companies?${queryString}`);
    return data.map((el: any) => ({
      name: el.trade_name,
      value: `${el.id}`,
    }));
  };

  const getListCompanyOldSelect = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get(`/companies?${queryString}`);
    return data.map((el: any) => ({
      label: `${el.code} - ${el.trade_name}`,
      value: el.id,
    }));
  };

    const fetchCompanies = async (payload: any): Promise<FetchCompaniesResponse> => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get<Company[]>(`/companies?${queryString}`);

    const options = data.map((company: Company) => ({
      value: String(company.id),
      label: `${company.code || '---'} - ${company.trade_name}`,
    }));

    return { data, options };
  };


  return {
    getListCompany,
    getListCompanyOldSelect,
    fetchCompanies,
  };
}
